import {
    ADDITIONAL_COMMENTS,
    CSAT_RESPONSE_VALUES,
    RATING_LABELS,
    THANK_YOU_MESSAGES
} from "../misc/constants";
import { Col, Row } from "reactstrap";

import Accordions from "@components/ui-components/accordions";
import CommonModal from "@components/ui-components/modal";
import { FormProvider } from "react-hook-form";
import InputField from "@components/fields/input-field";
import SurveyPreview from "./survey-preview";
import SwitchField from "@components/fields/switch-field";
import { useMemo } from "react";
// import SurveyPreview from "./survey-preview";
import useUpsert from "./use-upsert";

const UpsertSurvey = props => {

    const { modalConfig, handleModal } = props;
    const isEdit = !!modalConfig?.row?._id;

    const {
        methods,
        onSubmit,
        updateLoading,
        isDirty,
        loading,
        handleActiveId,
        activeId,
        handleActiveAccordion,
        activeAccordion
    } = useUpsert(props);

    const {
        control,
        watch,
        formState: { errors }
    } = methods;

    const surveyType = watch("survey_type");
    const enableAdditionalComments = watch("enable_additional_comments");

    const renderAdditionalComments = useMemo(() => {
        return ADDITIONAL_COMMENTS[surveyType]?.map(
            ({ title, id, placeholder }) => (
                <InputField
                    key={id}
                    label={title}
                    id={id}
                    name={id}
                    type="textarea"
                    placeholder={placeholder}
                    control={control}
                    errors={errors}/>
            )
        );
    }, [surveyType, control, errors]);

    const renderThankYouMessages = useMemo(() => {
        return THANK_YOU_MESSAGES[surveyType]?.map(
            ({ title, id, placeholder }) => (
                <InputField
                    key={id}
                    label={title}
                    id={id}
                    name={id}
                    type="textarea"
                    placeholder={placeholder}
                    control={control}
                    errors={errors}/>
            )
        );
    }, [surveyType, control, errors]);

    const renderResponseValues = useMemo(() => {
        return CSAT_RESPONSE_VALUES.map(({ title, id, placeholder }) => (
            <InputField
                key={id}
                label={title}
                id={id}
                name={id}
                placeholder={placeholder}
                control={control}
                errors={errors}/>
        ));
    }, [surveyType, control, errors]);

    const TABS = [
        {
            id     : "general",
            title  : "General",
            content: (
                <InputField
                    label="Survey name"
                    id="name"
                    name="name"
                    control={control}
                    errors={errors}
                    required/>
            )
        },
        {
            id     : "intro_message",
            title  : "Intro Message",
            content: (
                <InputField
                    label="Intro message (optional)"
                    id="additional_message"
                    name="additional_message"
                    type="textarea"
                    placeholder="Enter an introduction message for your survey"
                    control={control}
                    errors={errors}/>
            )
        },
        {   id     : "question",
            title  : "Question",
            content: (
                <>
                    <InputField
                        label="Question"
                        id="question_message"
                        name="question_message"
                        control={control}
                        errors={errors}
                        required/>
                    {surveyType === "csat" ? renderResponseValues : null}
                    <Row>
                        {RATING_LABELS.map(({ title, id, placeholder }) => (
                            <Col md={6} key={id}>
                                <InputField
                                    label={title}
                                    id={id}
                                    name={id}
                                    placeholder={placeholder}
                                    control={control}
                                    errors={errors}
                                    required/>
                            </Col>
                        ))}
                    </Row>
                </>
            )
        },
        {
            id     : "additional_comments",
            title  : "Additional Comments",
            content: (
                <>
                    <SwitchField
                        label="Enable additional comments"
                        id="enable_additional_comments"
                        customOnChange={val => {
                            if (!val) {
                                handleActiveId("additionalComment", "");
                            } else {
                                handleActiveId(
                                    "additionalComment",
                                    ADDITIONAL_COMMENTS[surveyType][0].id
                                );
                            }
                        }}
                        name="enable_additional_comments"
                        control={control}/>
                    {enableAdditionalComments && renderAdditionalComments}
                </>
            )
        },
        {   id     : "thank_you_message",
            title  : "Thank You Message",
            content: renderThankYouMessages
        }
    ];

    return (
        <FormProvider {...methods}>
            <CommonModal
                title={`${isEdit ? "Edit" : "Add"} Survey`}
                body={
                    <Row>
                        <Col md={8}>
                            <Accordions
                                state={activeAccordion}
                                className="border rounded"
                                toggle={handleActiveAccordion}
                                items={TABS}
                                controlled/>
                        </Col>
                        <Col md={4}>
                            <SurveyPreview activeId={activeId} />
                        </Col>
                    </Row>
                }
                confirmButton={{
                    txt    : isEdit ? "Update" : "Add",
                    icon   : "content-save",
                    onClick: onSubmit,
                    loading: updateLoading
                }}
                type="fullScreen"
                isDirty={isDirty}
                loading={loading}
                handleModal={handleModal}
                isOpen={modalConfig.isOpen}/>
        </FormProvider>
    );
};

export default UpsertSurvey;
